import { useEffect } from "react";

type PageSeoOptions = {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: "website" | "article";
};

const SITE_URL = "https://centralalvinegra.com.br";

function absoluteUrl(value?: string) {
  const url = String(value || "").trim();
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${SITE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

function updateMeta(name: string, content: string) {
  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", content);
}

function updateProperty(property: string, content: string) {
  let meta = document.querySelector(`meta[property="${property}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", content);
}

export function usePageSeo({ title, description, keywords, image, url, type }: PageSeoOptions) {
  useEffect(() => {
    const absoluteImage = absoluteUrl(image);

    document.title = title;
    updateMeta("description", description);

    if (keywords) {
      updateMeta("keywords", keywords);
    }

    updateProperty("og:title", title);
    updateProperty("og:description", description);
    updateProperty("og:type", type || "website");
    updateMeta("twitter:title", title);
    updateMeta("twitter:description", description);
    updateMeta("twitter:card", "summary_large_image");

    if (absoluteImage) {
      updateProperty("og:image", absoluteImage);
      updateMeta("twitter:image", absoluteImage);
    }

    if (url) {
      updateProperty("og:url", url);

      let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }

      canonical.setAttribute("href", url);
    }
  }, [title, description, keywords, image, url, type]);
}
